(() => {
  const root = window;

  function createBlogIndex(config = {}) {
    return {
      activeTopic: '',
      page: 1,
      perPage: Number(config.articlesPerPage) || 9,
      sortOpen: false,
      sortOrder: 'newest',

      init() {
        if (this.page > this.totalPages) {
          this.page = this.totalPages;
        }
      },

      get allCards() {
        if (!this.$refs.cards) {
          return [];
        }

        return Array.from(this.$refs.cards.querySelectorAll('[data-blog-article]'));
      },

      get visibleCards() {
        const matchedCards = this.allCards.filter((card) => this.cardMatchesTopic(card));
        const cards = this.activeTopic ? matchedCards : this.allCards;

        return cards.sort((firstCard, secondCard) => {
          const firstDate = Number(firstCard.dataset.blogDate) || 0;
          const secondDate = Number(secondCard.dataset.blogDate) || 0;

          if (this.sortOrder === 'oldest') {
            return firstDate - secondDate;
          }

          return secondDate - firstDate;
        });
      },

      get visibleCount() {
        return this.visibleCards.length;
      },

      get totalPages() {
        return Math.max(1, Math.ceil(this.visibleCount / this.perPage));
      },

      get pageNumbers() {
        return Array.from({ length: this.totalPages }, (_item, index) => index + 1);
      },

      cardMatchesTopic(card) {
        if (!this.activeTopic) {
          return true;
        }

        const tags = (card.dataset.blogTags || '').split('||').map((tag) => tag.trim());

        return tags.includes(this.activeTopic);
      },

      isCardVisible(card) {
        const cards = this.visibleCards;
        const index = cards.indexOf(card);

        if (index === -1) {
          return false;
        }

        const start = (this.page - 1) * this.perPage;
        const end = start + this.perPage;

        return index >= start && index < end;
      },

      selectTopic(topic) {
        this.activeTopic = topic;
        this.page = 1;
      },

      setSort(sortOrder) {
        this.sortOrder = sortOrder;
        this.sortOpen = false;
        this.page = 1;
      },

      goToPage(pageNumber) {
        this.page = Math.min(Math.max(pageNumber, 1), this.totalPages);
      },

      previousPage() {
        this.goToPage(this.page - 1);
      },

      nextPage() {
        this.goToPage(this.page + 1);
      }
    };
  }

  function registerBlogIndex() {
    if (!root.Alpine) {
      return;
    }

    root.Alpine.data('blogIndex', createBlogIndex);
  }

  if (root.Alpine) {
    registerBlogIndex();
  } else {
    root.document.addEventListener('alpine:init', registerBlogIndex, { once: true });
  }
})();
